import { apiClient } from "../config";

async function archiveOrRestoreProgram(id: any, status: any) {
  const url = `/admin/programs/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreProgram;
